import './App.css';
import BewerbungsFragebogen from './components/BewerbungsFragebogen';

function App() {
  return (
    <div className="App">
      <BewerbungsFragebogen />
    </div>
  );
}

export default App;
